module.exports = __webpack_public_path__ + "static/media/Grotesk Light.7fa12c5f.ttf";